import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { u as useIntl } from '../../LocalModules/storm-ui-intl/dist/esm/3rdPartyModules/react-intl/lib/src/components/useIntl-voJ4yxcS-DU7lWLPF.js';
import { u as useTaktId } from '../../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { T as TextButton } from '../../Button/TextButton/TextButton-Ca8KdYfe.js';

const CancelButton = ({
  onCancel,
  taktId,
  children,
  ...rest
}) => {
  const {
    formatMessage
  } = useIntl();
  const {
    dataTaktId
  } = useTaktId({
    taktId,
    fallbackId: createStormTaktId('cancel-button')
  });
  return /*#__PURE__*/React__default.createElement(TextButton, _extends({}, rest, {
    onClick: onCancel,
    taktId: dataTaktId
  }), children !== null && children !== void 0 ? children : formatMessage({
    id: 'cancel'
  }));
};

export { CancelButton as C };
//# sourceMappingURL=CancelButton-BFhcUZXw.js.map
